import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown as DD } from 'primereact/dropdown';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';
import OptionValidator from '../FormComponenets/OptionValidator';

export default function Dropdown({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, label, required, options = [] } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  const _label = item?.res_type === 'custom-field' ? item?.name : label;
  const _options = item?.res_type === 'custom-field' ? item?.listOptions?.map((v) => ({ label: v?.option, value: v?.option })) : options;

  return (
    <div className="w-100">
      <LabelName>
        {_label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field, fieldState }) => (
            <DD
              id={field.name}
              options={_options}
              onChange={(e) => field.onChange(e.value)}
              value={field.value}
              placeholder="Select"
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              inputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
        {isFormBuilder && item?.res_type !== 'custom-field' && (
          <span className="add-option" onClick={() => handleSettingsClick(item)}>
            + Add Options
          </span>
        )}
        {isFormBuilder && item?.res_type !== 'custom-field' && <OptionValidator name={`form_data.${index}.options`} />}
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
